module.exports = __webpack_public_path__ + "img/stripes.71655f96.svg";